import { FinalizaProcedimento } from './finaliza-procedimento';


export class FinalizaGTO {
    constructor(
        public numero?: number,
        public dataFinalizacao?: Date,
        public procedimentos?: Array<FinalizaProcedimento>,
        public error?: boolean,
        public errorMessage?: string
    ) { }
}



// WEBPACK FOOTER //
// ./src/app/components/base/vo/finaliza-gto.ts